import React from 'react';
import { AppButton, Box, FiservCardInterface, getUtcDate, Text } from '@common-fe/common-fe';

import { DEFAULT_DATE_FORMAT, EMPTY_FIELD_VALUE } from '@/common/constants';

export interface CardDetailsTableItemProps {
  id: string;
  isLastIndex?: boolean;
  label: string;
  children: React.ReactNode;
  isMobileMode?: boolean;
}
const CardDetailsTableItem: React.FC<CardDetailsTableItemProps> = ({
  id,
  label,
  children,
  isLastIndex,
  isMobileMode,
}) => {
  return (
    <Text size="small" color="textSecondary">
      <Text color="textSecondary" weight={500} data-testId={`CardDetailsTable_${id}_label`} size="small">
        {label}:{' '}
      </Text>
      <Text weight={700} size="small" data-testId={`CardDetailsTable_${id}`} color="textBody">
        {children}
      </Text>
      {!isLastIndex && (
        <Text
          color="textSecondary"
          data-testId={`CardDetailsTable_${id}_delimiter`}
          margin={{ horizontal: 'spacing4' }}
        >
          •
        </Text>
      )}
    </Text>
  );
};
interface Props {
  card: FiservCardInterface;
  onClick: () => void;
}

const CardDetailsTable: React.FC<Props> = ({ card, onClick }) => (
  <Box
    background="canvas"
    round="container1Round"
    direction="row"
    pad={{ vertical: 'spacing12', horizontal: 'spacing24' }}
  >
    <Box flex="grow" direction="row" pad="spacing12">
      <CardDetailsTableItem id="cardRequestDate" label="Card Request Date">
        {card.cardRequestDate
          ? getUtcDate(card.cardRequestDate).format(DEFAULT_DATE_FORMAT)
          : EMPTY_FIELD_VALUE}
      </CardDetailsTableItem>
      <CardDetailsTableItem id="issuedDate" label="Mailed Date">
        {card.mailedDate ? getUtcDate(card.mailedDate).format(DEFAULT_DATE_FORMAT) : EMPTY_FIELD_VALUE}
      </CardDetailsTableItem>
      <CardDetailsTableItem id="activationDate" label="Activation Date">
        {card.activationDate
          ? getUtcDate(card.activationDate).format(DEFAULT_DATE_FORMAT)
          : EMPTY_FIELD_VALUE}
      </CardDetailsTableItem>

      <CardDetailsTableItem id="expDate" label="Expiration Date" isLastIndex>
        {card.expDate ? getUtcDate(card.expDate).format(DEFAULT_DATE_FORMAT) : EMPTY_FIELD_VALUE}
      </CardDetailsTableItem>
    </Box>
    <Box>
      <AppButton buttonType="secondary" width="165px" onClick={onClick}>
        Manage Card
      </AppButton>
    </Box>
  </Box>
);

export default CardDetailsTable;
